module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/public-sciences-2-03e74be212757ef3c47c96b4762c5766.jpg";